import Provider from "./Provider-Api";
import CheckApi from "./check-api";

export const pettyCashGetPettyCash = async (data, token) => {
    CheckApi('getPettyCash', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/pettyCash/getPettyCash",
        data,
        token
    });
    CheckApi('dataRes-getPettyCash', dataRes)
    return dataRes;
};

export const pettyCashGetPettyCashToDay = async (data, token) => {
    CheckApi('getPettyCashToDay', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/pettyCash/getPettyCashToDay",
        data,
        token
    });
    CheckApi('dataRes-getPettyCashToDay', dataRes)
    return dataRes;
};

export const pettyCashGetPettyCashTopbar = async (data, token) => {
    CheckApi('getPettyCashTopbar', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/pettyCash/getPettyCashTopbar",
        data,
        token
    });
    CheckApi('dataRes-getPettyCashTopbar', dataRes)
    return dataRes;
};


export const pettyCashAddPettyCash = async (data, token) => {
    CheckApi('addPettyCash', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/pettyCash/addPettyCash",
        data,
        token
    });
    CheckApi('dataRes-addPettyCash', dataRes)
    return dataRes;
};